import * as React from 'react'
import RadioGroup from '@mui/material/RadioGroup'
import FormControl from '@mui/material/FormControl'
import { Controller, useFormContext } from 'react-hook-form'
import { FormLabel, Grid, Stack } from '@mui/material'
import { EFTypography } from '../EFTypography'
import { EFRadiosProps } from './EFRadio.model'
import EFRadioGroupBasic from './EFCustomizedRadioGroup'

export const EFRadios = React.forwardRef(
  (props: EFRadiosProps, _ref: React.ForwardedRef<unknown>) => {
    const {
      name,
      value,
      onChange,
      children,
      label,
      isHorizontal,
      labelWidth,
      alignLabel,
      isHorizontalCheckBox,
      ...radioProps
    } = props

    const gridStyle = {
      pt: '0.5rem !important',
      pb: '0.5rem !important',
      paddingRight: 3,
      spacing: 2,
      paddingY: 1
    }
    const { control } = useFormContext() ?? {}
    if (!control) return <EFRadioGroupBasic {...props} />

    if (!isHorizontal)
      return (
        <FormControl>
          {label && <FormLabel id='customized-radios'>{label}</FormLabel>}
          <Controller
            rules={{ required: true }}
            control={control}
            name={name ?? ''}
            render={({ field }) => (
              <RadioGroup
                {...field}
                {...radioProps}
                value={field.value ?? false}
                aria-labelledby='customized-radios'
                name='customized-radios'
              >
                {children}
              </RadioGroup>
            )}
          />
        </FormControl>
      )

    return (
      <Grid
        container
        spacing={gridStyle.spacing}
        paddingY={gridStyle.paddingY}
      >
        {label && (
          <Grid
            item
            xs={labelWidth}
            textAlign={alignLabel}
            pt={gridStyle.pt}
            pb={gridStyle.pb}
            paddingRight={gridStyle.paddingRight}
          >
            <EFTypography fontSize='1rem' >{label}</EFTypography>
          </Grid>
        )}
        <Grid
          item
          pt='0rem !important'
        >
          <FormControl>
            <Controller
              rules={{ required: true }}
              control={control}
              name={name ?? ''}
              render={({ field }) => (
                <RadioGroup
                  {...field}
                  {...radioProps}
                  value={field.value ?? false}
                  aria-labelledby='customized-radios'
                  name='customized-radios'
                >
                  <Stack direction={isHorizontalCheckBox ? 'row' : 'column'}>
                    {children}
                  </Stack>
                </RadioGroup>
              )}
            />
          </FormControl>
        </Grid>
      </Grid>
    )
  }
)
